module.exports = __webpack_public_path__ + "img/activity_ico3.443cf09b.png";